import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';

interface ConfirmDeleteSchemaDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  schemaName: string;
  deleting?: boolean;
}

const ConfirmDeleteSchemaDialog: React.FC<ConfirmDeleteSchemaDialogProps> = ({
  open,
  onClose,
  onConfirm,
  schemaName,
  deleting = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={deleting ? undefined : onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningIcon color="warning" fontSize="large" />
          <Typography variant="h6">Confirmar Eliminación</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          ¿Está seguro que desea eliminar el siguiente esquema?
        </Typography>
        <Box
          sx={{
            p: 2,
            backgroundColor: '#f5f5f5',
            borderRadius: 1,
            borderLeft: '4px solid #ff9800',
          }}
        >
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Esquema:
          </Typography>
          <Typography variant="body1" fontWeight="bold">
            {schemaName}
          </Typography>
        </Box>
        <Typography variant="body2" color="error" sx={{ mt: 2 }}>
          Esta acción no se puede deshacer.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={deleting}
        >
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={deleting}
          startIcon={deleting ? <CircularProgress size={20} /> : null}
        >
          {deleting ? 'Eliminando...' : 'Eliminar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteSchemaDialog;
